// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6fbd733e","703":"aab122af","787":"b94ebae5"}[chunkId] + ".chunk.js";
};